<div class="header-popover-button">
	<!-- NOTIFICATION FUNCTIONALITY -->
	<af-notification-badge *ngIf="this.ionicEnvironment.notificationsEnabled && !disableNotificationButton"></af-notification-badge>
	<ion-button (click)="presentHeaderPopover($event)" data-test="headerellipsis-button">
		<fa-icon [fixedWidth]="true" [icon]="['fal', 'ellipsis-v']" size="lg" slot="icon-only"></fa-icon>
	</ion-button>
</div>
